import { Box, Button, Stack } from "@mui/material";
import React, { useState, useEffect } from "react";
import { engApi } from "../../api/engApi";
import MergeCompany from "../MergeCompany";
import ModalView from "../ModalView";
import DrawerReviewCompany from "./DrawerReviewCompany";

const WaitingCompany = () => {
  const [watingCompany, setWatingCompany] = useState([]);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [companySelected, setCompanySelected] = useState(null);
  const [isMergeModalOpen, setIsMergeModalOpen] = useState(false);

  const [companySource, setCompanySource] = useState(null);
  const [companyTarget, setCompanyTarget] = useState(null);
  const [modalDeleteOpen, setModalDeleteOpen] = useState(false);

  const onSelectCompany = (company) => {
    setIsOpenDrawer(true);
    setCompanySelected(company);
  };

  const getWaitingCompany = () => {
    engApi
      .get("/waiting-company/")
      .then((res) => {
        setWatingCompany(res.data ?? []);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCompantMergeClick = (ev) => {
    setIsMergeModalOpen(true);
    setCompanySource(ev);
  };
  const onDeleteClick = (ev) => {
    setModalDeleteOpen(true);
    setCompanySelected(ev);
  };

  const onHandleDelete = () => {};

  useEffect(() => {
    getWaitingCompany();
  }, []);

  console.log({ watingCompany });

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <h5 className="card-title">สถานประกอบการใหม่รอตรวจสอบ</h5>
          <h6 className="card-subtitle text-muted"></h6>
        </div>
        <div className="card-body">
          <div id="tasks-upcoming">
            {!!watingCompany.length
              ? watingCompany.map((el, elIndex) => {
                  return (
                    <div className="card mb-3 bg-light border" key={elIndex}>
                      <div className="card-body p-3">
                        <div className="float-end mr-n2">ID : {el.id}</div>
                        <h6>{el.name}</h6>
                        <p>
                          {el?.address} ต.
                          {el?.subdistrict} อ.
                          {el?.district} จ.
                          {el?.province} {el?.zip}
                        </p>

                        {!!el.waiting == 1 && (
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => onSelectCompany(el)}
                          >
                            ตรวจสอบ
                          </button>
                        )}

                        {!!!el.st_object?.length && (
                          <button
                            className="btn btn-sm btn-outline-danger ms-3"
                            onClick={() => {
                              onDeleteClick(el);
                            }}
                          >
                            ลบบริษัท
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })
              : "ไม่มีสถานประกอบการใหม่"}
          </div>
        </div>
      </div>
      <DrawerReviewCompany
        isOpen={isOpenDrawer}
        setIsOpen={setIsOpenDrawer}
        companySelected={companySelected}
        setCompanySelected={setCompanySelected}
      />
      <ModalView
        isModaOpen={modalDeleteOpen}
        setIsModalOpen={setModalDeleteOpen}
        title="ยืนยันลบบริษัทใช่หรือไม่"
      >
        <div style={{ width: "400px" }}>
          <form action="./delete-company.php" method="post">
            <input
              className="d-none"
              value={companySelected?.id}
              name="cp_id"
            />
            <Stack direction="row-reverse" spacing={3} mt={2}>
              <Button variant="contained" type="submit">
                ยืนยัน
              </Button>
              <Button
                onClick={() => {
                  setModalDeleteOpen(false);
                  setCompanySelected(null);
                }}
              >
                ยกเลิก
              </Button>
            </Stack>
          </form>
        </div>
      </ModalView>
    </div>
  );
};

export default WaitingCompany;
